"use client"
// src/blocks/button/button.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Button = ({
  a11yLabel,
  children,
  className,
  icon,
  label,
  popovertarget,
  onClick,
  tracking,
  ...rest
}) => {
  const shouldRender = icon || label || children;
  if (!shouldRender) return null;
  return /* @__PURE__ */ jsxs(
    "button",
    {
      popoverTarget: popovertarget,
      onClick,
      "aria-label": a11yLabel ?? label,
      className,
      ...rest,
      children: [
        children,
        label && /* @__PURE__ */ jsx("span", { children: label }),
        icon
      ]
    }
  );
};
var button_default = Button;

export {
  button_default
};
